export class ForgotPasswordRequest {
  constructor(public email: string, public typeNotify: string) { }
}
